// App version — bump on each deploy so the live footer confirms which build is running.
export const APP_VERSION = "1.18.0";

// Contract addresses - Update these with your deployed contracts
export const CONTRACTS = {
  VAT: "0x7086692dEe57ebEf0dC66A786198C406CfC259cD",
  SPOTTER: "0x08E744BBe065911F45B86812a0F783bB35fb65eb",
  MEDIANIZER: "0x361630052FfbA8b40473A142264932eBD482426D",
  JDAI: "0x1610E75C9b48BF550137820452dE4049bB22bB72",
  PLS: "0xA1077a294dDE1B09bB078844df40758a5D0f9a27", // Wrapped PLS (WPLS) - NOT USED with ETHJoin
  ETHJOIN: "0x7a86c0a6078FA1e2053b0ff9d015B39387570162", // This is actually an ETHJoin for native PLS
  DAIJOIN: "0xBD767F3Fbdc24c5761e6c2a6C936986683584Ad8",
  JUG: "0xa2817B5a84F0f0fC182D1fB2FAD4Fd7E7dbb762E",
  TKR: "0xd9e59020089916A8EfA7Dd0B605d55219D72dB7B",
  JDAI_PLS_PAIR: "0x70658Ce6D6C09acdE646F6ea9C57Ba64f4Dc350f",
  // PulseX v2 WPLS/DAI (bridged DAI, both 18 decimals) — real market PLS/USD feed,
  // independent of the system oracle, for the market-vs-oracle comparison in the UI.
  WPLS_DAI_PAIR: "0x146E1f1e060e5b5016Db0D118D2C5a11A240ae32",

  // --- Easy Vault stack (WPLS-A ilk), deployed 2026-08-29, Sourcify exact_match ---
  GEMJOIN_WPLS_A: "0x7dCd4ada3774dDA48dD289393802b4ac8F9e5c66",
  CDP_MANAGER: "0xD7daE04134bB4c48a613350689945D3A70B794a3",
  // MakerDAO's audited proxy stack, present on PulseChain at the Ethereum addresses
  // via the fork — reused unchanged, never redeployed.
  PROXY_REGISTRY: "0x4678f0a6958e4D2Bc4F1BAF7Bc52E8F3564f3fE4",
  PROXY_ACTIONS: "0x82ecD135Dce65Fbc6DbdD0e4237E0AF93FFD5038",
  GET_CDPS: "0x36a724Bd100c39f0Ea4D3A20F7097eE01A8Ff573",

  // --- Accounting + liquidations + auctions (deployed 2026-08-29, Sourcify
  // exact_match, wired COLD — installed but deliberately inactive) ---
  VOW: "0xdAb64401abD00686eA7a00dae976A0E8259d2312",
  DOG: "0x80b1aE4c31202880C7AD123C5c3bc2842F8b0ef2",
  CLIPPER_PLS_A: "0x18d560BC52167f45287C9B2389973d448A491D2B",
  CLIPPER_WPLS_A: "0x06DBd4003e824ecAfe3829A9e06c70E096b0CEDd",
  CALC: "0x975a2CF9578422bB3fdF6F3B1e8D1951bc2C478E",
  FLAPPER: "0xe70c043832ddD007a2170244acA6e770DF6Ac27b",
  FLOPPER: "0xb280fC0F60754A15847212A4caB2f247ED260E61",
  GOV_GUARD: "0x5DF4d24B2d469d7C31662C8D4f2A848250c1aA67"
};

// QA gate for the Auctions tab. Empty = public for everyone (current state —
// the drill vetted the full stack on 2026-08-30). Re-add lowercase addresses
// here to re-gate during any future QA cycle.
export const AUCTIONS_QA_ALLOWLIST = [];

// Public PulseChain RPC endpoints (first is primary, the rest are fallbacks).
export const RPC_URLS = [
  "https://rpc.pulsechain.com",
  "https://rpc-pulsechain.g4mm4.io",
  "https://pulsechain-rpc.publicnode.com"
];

// DexScreener pair addresses (display links only).
export const DEXSCREENER = {
  JDAI: "0x1610E75C9b48BF550137820452dE4049bB22bB72",
  TKR: "0x205c6d44d84e82606e4e921f87b51b71ba85f0f0"
};

// PulseChain network configuration
export const PULSECHAIN_CONFIG = {
  chainId: 369,
  chainName: "PulseChain",
  rpcUrls: RPC_URLS,
  blockExplorerUrls: ["https://scan.mypinata.cloud/ipfs/bafybeidn64pd2u525lmoipjl4nh3ooa2imd7huionjsdepdsphl5slfowy/"],
  nativeCurrency: {
    name: "PLS",
    symbol: "PLS",
    decimals: 18
  }
};

// ILK identifier for PLS collateral
export const ILK = "0x504c532d41000000000000000000000000000000000000000000000000000000"; // "PLS-A"
// ILK for the Easy Vault collateral (wrapped PLS via GemJoin)
export const ILK_WPLS = "0x57504c532d410000000000000000000000000000000000000000000000000000"; // "WPLS-A"

// Contract ABIs
export const ABIS = {  VAT: [
    "function hope(address usr) external",
    "function can(address,address) external view returns (uint256)",
    "function ilks(bytes32) external view returns (uint256 Art, uint256 rate, uint256 spot, uint256 line, uint256 dust)",
    "function urns(bytes32,address) external view returns (uint256 ink, uint256 art)",
    "function frob(bytes32 i, address u, address v, address w, int dink, int dart) external",
    "function wipe(bytes32 i, address u, uint256 rad) external",
    "function dai(address) external view returns (uint256)",
    "function sin(address) external view returns (uint256)",
    "function gem(bytes32,address) external view returns (uint256)",
    "function Line() external view returns (uint256)",
    "function live() external view returns (uint256)",
    "function debt() external view returns (uint256)",
    "function vice() external view returns (uint256)"
  ],    ETHJOIN: [
    "function join(address usr) external payable",
    "function exit(address payable usr, uint wad) external",
    "function vat() external view returns (address)",
    "function ilk() external view returns (bytes32)",
    "function live() external view returns (uint256)",
    "function wards(address) external view returns (uint256)",
    "function rely(address usr) external",
    "function deny(address usr) external",
    "function cage() external"
  ],
  
  DAIJOIN: [
    "function join(address usr, uint wad) external",
    "function exit(address usr, uint wad) external",
    "function vat() external view returns (address)",
    "function dai() external view returns (address)"
  ],
    JDAI: [
    "function balanceOf(address) external view returns (uint256)",
    "function totalSupply() external view returns (uint256)",
    "function approve(address spender, uint256 amount) external returns (bool)",
    "function allowance(address owner, address spender) external view returns (uint256)",
    "function name() external view returns (string)",
    "function symbol() external view returns (string)",
    "function decimals() external view returns (uint8)"
  ],

  PLS: [
    "function balanceOf(address) external view returns (uint256)",
    "function approve(address spender, uint256 amount) external returns (bool)",
    "function allowance(address owner, address spender) external view returns (uint256)",
    "function deposit() external payable",
    "function withdraw(uint256 wad) external",
    "function name() external view returns (string)",
    "function symbol() external view returns (string)",
    "function decimals() external view returns (uint8)"
  ],
    SPOTTER: [
    "function par() external view returns (uint256)",
    "function ilks(bytes32) external view returns (address pip, uint256 mat)",
    "function poke(bytes32 ilk) external",
    "function live() external view returns (uint256)"
  ],
  
  MEDIANIZER: [
    "function read() external view returns (bytes32)",
    "function peek() external view returns (bytes32, bool)",
    "function age() external view returns (uint32)",
    "function bar() external view returns (uint256)"
  ],

  JUG: [
    "function ilks(bytes32) external view returns (uint256 duty, uint256 rho)",
    "function base() external view returns (uint256)"
  ],

  // --- Auctions (Phase D/E — installed cold; UI reads always, acts when live) ---
  DOG: [
    "function Hole() external view returns (uint256)",
    "function Dirt() external view returns (uint256)",
    "function ilks(bytes32) external view returns (address clip, uint256 chop, uint256 hole, uint256 dirt)",
    "function bark(bytes32 ilk, address urn, address kpr) external returns (uint256)"
  ],
  CLIPPER: [
    "function kicks() external view returns (uint256)",
    "function count() external view returns (uint256)",
    "function list() external view returns (uint256[])",
    "function sales(uint256) external view returns (uint256 pos, uint256 tab, uint256 lot, address usr, uint96 tic, uint256 top)",
    "function getStatus(uint256) external view returns (bool needsRedo, uint256 price, uint256 lot, uint256 tab)",
    "function chost() external view returns (uint256)",
    "function tip() external view returns (uint192)",
    "function chip() external view returns (uint64)",
    "function buf() external view returns (uint256)",
    "function tail() external view returns (uint256)",
    "function cusp() external view returns (uint256)",
    "function take(uint256 id, uint256 amt, uint256 max, address who, bytes data) external",
    "function redo(uint256 id, address kpr) external"
  ],
  VOW_AUCTION: [
    "function bump() external view returns (uint256)",
    "function hump() external view returns (uint256)",
    "function sump() external view returns (uint256)",
    "function dump() external view returns (uint256)",
    "function wait() external view returns (uint256)",
    "function Sin() external view returns (uint256)",
    "function Ash() external view returns (uint256)",
    "function flap() external returns (uint256)",
    "function flop() external returns (uint256)",
    "function heal(uint256 rad) external",
    "function flog(uint256 era) external"
  ],
  FLAPPER: [
    "function kicks() external view returns (uint256)",
    "function live() external view returns (uint256)",
    "function beg() external view returns (uint256)",
    "function ttl() external view returns (uint48)",
    "function tau() external view returns (uint48)",
    "function bids(uint256) external view returns (uint256 bid, uint256 lot, address guy, uint48 tic, uint48 end)",
    "function tend(uint256 id, uint256 lot, uint256 bid) external",
    "function tick(uint256 id) external",
    "function deal(uint256 id) external"
  ],
  FLOPPER: [
    "function kicks() external view returns (uint256)",
    "function live() external view returns (uint256)",
    "function beg() external view returns (uint256)",
    "function pad() external view returns (uint256)",
    "function ttl() external view returns (uint48)",
    "function tau() external view returns (uint48)",
    "function bids(uint256) external view returns (uint256 bid, uint256 lot, address guy, uint48 tic, uint48 end)",
    "function dent(uint256 id, uint256 lot, uint256 bid) external",
    "function tick(uint256 id) external",
    "function deal(uint256 id) external"
  ],
  CALC: [
    "function cut() external view returns (uint256)",
    "function step() external view returns (uint256)"
  ],
  GEMJOIN: [
    "function join(address usr, uint256 wad) external",
    "function exit(address usr, uint256 wad) external"
  ],
  TKR: [
    "function authority() external view returns (address)",
    "function owner() external view returns (address)",
    "function balanceOf(address) external view returns (uint256)",
    "function totalSupply() external view returns (uint256)",
    "function allowance(address, address) external view returns (uint256)",
    "function approve(address, uint256) external returns (bool)"
  ],

  // --- Easy Vault (MakerDAO proxy stack) ---
  PROXY_REGISTRY: [
    "function build() external returns (address)",
    "function proxies(address) external view returns (address)"
  ],
  DS_PROXY: [
    "function execute(address _target, bytes _data) external payable returns (bytes)",
    "function owner() external view returns (address)"
  ],
  PROXY_ACTIONS: [
    "function openLockETHAndDraw(address manager, address jug, address ethJoin, address daiJoin, bytes32 ilk, uint256 wadD) external payable",
    "function lockETHAndDraw(address manager, address jug, address ethJoin, address daiJoin, uint256 cdp, uint256 wadD) external payable",
    "function lockETH(address manager, address ethJoin, uint256 cdp) external payable",
    "function draw(address manager, address jug, address daiJoin, uint256 cdp, uint256 wad) external",
    "function wipe(address manager, address daiJoin, uint256 cdp, uint256 wad) external",
    "function wipeAll(address manager, address daiJoin, uint256 cdp) external",
    "function freeETH(address manager, address ethJoin, uint256 cdp, uint256 wad) external",
    "function wipeAndFreeETH(address manager, address ethJoin, address daiJoin, uint256 cdp, uint256 wadC, uint256 wadD) external",
    "function wipeAllAndFreeETH(address manager, address ethJoin, address daiJoin, uint256 cdp, uint256 wadC) external",
    "function exitETH(address manager, address ethJoin, uint256 cdp, uint256 wad) external"
  ],
  CDP_MANAGER: [
    "function cdpi() external view returns (uint256)",
    "function urns(uint256) external view returns (address)",
    "function owns(uint256) external view returns (address)",
    "function ilks(uint256) external view returns (bytes32)"
  ],
  GET_CDPS: [
    "function getCdpsAsc(address manager, address guy) external view returns (uint256[] ids, address[] urns, bytes32[] ilks)"
  ]
};
